import type { BadgeVariant } from '@/types/common.types';

/**
 * The Stage badge colour on the plan lists (Plans, Inquiries, Consults), from
 * the stage name. Stage names are per-account, so this matches loosely on the
 * words they share.
 */
export function getStageBadgeVariant(stageName: string | null): BadgeVariant {
  if (!stageName) return 'neutral';
  const lower = stageName.toLowerCase();
  if (lower.includes('inquiry') || lower.includes('lead')) return 'info';
  if (lower.includes('consult')) return 'info';
  if (lower.includes('surg') || lower.includes('schedul') || lower.includes('proced')) return 'warning';
  if (lower.includes('complete') || lower.includes('post')) return 'success';
  if (lower.includes('no show') || lower.includes('noshow')) return 'error';
  return 'neutral';
}
